import {Select} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {IoChevronDown} from 'react-icons/io5'
import {deepTranslate, NullAsDefault} from 'views/Shared'
import {SummaryFilterOptions} from '../WorkspaceContext'
import {InsightsBlockHeader} from './WorkspaceInsights'

export const InsightsSummaryTypes = Object.freeze({
  DEFAULT: 'default',
  HOST_LEFT_LIST: 'host-left-list',
  HOST_RIGHT_LIST: 'host-right-list',
})

export const PeriodFilterHeader = ({
  title,
  value,
  hashId,
  defaultValue,
  visible = true,
  onSelect = NullAsDefault,
  options = [
    SummaryFilterOptions.THISMONTH,
    SummaryFilterOptions.YESTERDAY,
    SummaryFilterOptions.TODAY,
    SummaryFilterOptions.LAST7DAYS,
    SummaryFilterOptions.LASTMONTH,
    SummaryFilterOptions.THISYEAR,
    SummaryFilterOptions.LASTYEAR,
    SummaryFilterOptions.LAST3YEAR,
  ],
}) => {
  const t = useTranslate()

  const hasFilter = !_.isEmpty(options) && !!visible

  const _options = useMemo(() => {
    return Array.from(options).map(deepTranslate(t))
  }, [t, options])

  return (
    <InsightsBlockHeader
      id={hashId}
      title={title}>
      {hasFilter && (
        <Select
          size="small"
          value={value}
          options={_options}
          onSelect={onSelect}
          style={{ width: 110 }}
          defaultValue={defaultValue}
          className="text-xs text-color-300"
          suffixIcon={<IoChevronDown className="text-color-300" />}
        />
      )}
    </InsightsBlockHeader>
  )
}
